"use strict";

define('model/organization',['require','exports','module','underscore','./base','collection/base','./organization.approver'],function (require, exports, module) {
  var _ = require('underscore');
  var BaseModel = require('./base');
  var BaseCollection = require('collection/base');
  var OrganizationApprover = require('./organization.approver');
  var Organization = BaseModel.extend({
    urlRoot: '/rs/api/org',
    childModels: {
      children: 'Organization'
    },
    defaults: function defaults() {
      return {
        children: []
      };
    },
    approvers: function approvers() {
      return OrganizationApprover.all(this.id);
    }
  }, {
    all: function all(params) {
      return this.createCollection(this.prototype.urlRoot).addAdapter({
        preprocess: function preprocess(options) {
          options.data = _.extend({}, options.data, params);
        }
      });
    }
  });
  Organization.FlatOrgsCollection = BaseCollection.extend({
    model: Organization,
    url: '/rs/api/org?flat=true&full=true',
    comparator: function comparator(orgModel) {
      return String(orgModel.get('title')).toLowerCase();
    },
    parse: function parse() {
      return BaseCollection.prototype.parse.apply(this, arguments);
    }
  });
  module.exports = Organization;
});

